if not App.angularApp?
    return

App.angularApp.directive 'mfCenterDialog', ['$window', '$timeout', '$parse', ($window, $timeout, $parse) ->
    return {
        link: (scope, ele, attrs) ->
            sizingOpts = attrs.mfCenterDialog
            opts = $parse(sizingOpts)(scope)

            $timeout () =>
                # find the element of the dialog
                dlg = ele.closest('[uib-modal-window]')

                # set the margins to 0 so that positioning makes sense
                pos = # {}
                    margin: '0px'
                    top: 'auto'
                    bottom: 'auto'
                    left: 'auto'
                    right: 'auto'

                # set the x coordinate
                windowWidth = angular.element($window).width()
                dialogWidth = dlg.outerWidth()
                widthDiff = windowWidth - dialogWidth

                if widthDiff < 0
                    pos.left = widthDiff
                else
                    pos.left = widthDiff / 2

                pos.left += 'px'

                # set the y coordinate
                windowHeight = angular.element($window).height()
                dialogHeight = dlg.outerHeight()
                heightDiff = windowHeight - dialogHeight

                if heightDiff < 0
                    pos.top = heightDiff
                else
                    pos.top = heightDiff / 2

                if opts?.topOffset?
                    pos.top -= opts.topOffset

                pos.top += 'px'

                dlg.css pos
    }
]
